module.exports = "<div :style=\"{height:app.height+'px',width:app.width+'px'}\" class=\"v-317b8531\">\n        <div class=\"icon {{openedFile.icon}}\"></div>\n        <h1>{{openedFile.name}}</h1>\n        <p>目标: <input type=\"text\" disabled=\"\" value=\"{{openedFile.app}}\"></p>\n        <main>\n            <pre>{{ openedFile.options.data | json }}</pre>\n        </main>\n    </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/props.vue
 ** module id = 87
 ** module chunks = 0
 **/